import React, {useCallback, useEffect, useState} from "react";
import styles from "components/Navigation/Navigation.module.css";
import {useTranslation} from "react-i18next";
import {Link, withRouter} from "react-router-dom";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import {ReactComponent as ProfileIcon} from "assets/icons/user.svg";
import {
  ReactComponent as ContractorsListIcon,
  ReactComponent as FerryServicesListIcon,
  ReactComponent as OrdersListIcon,
  ReactComponent as CustomFieldsListIcon,
  ReactComponent as GroupsListIcon,
  ReactComponent as UserGroupsListIcon,
  ReactComponent as AdminPanelIcon,
} from "assets/icons/list.svg";
import {ReactComponent as CarsListIcon} from "assets/icons/car.svg";
import {ReactComponent as UsersListIcon} from "assets/icons/users-list.svg";
import {ReactComponent as DriversListIcon} from "assets/icons/drivers-list.svg";
import classNames from "classnames";
import {AccessControl} from "components/Shared/AccessControl";
import Slide from "@material-ui/core/Slide";
import {NotificationsList} from "components/Notification";
import {
  CAR_READ,
  CONTRACTOR_READ,
  CUSTOM_FIELDS_READ,
  DRIVER_READ,
  FERRY_SERVICE_READ,
  MY_PROFILE_READ,
  ORDER_READ,
  USER_GROUP_READ,
  GROUP_READ,
  USER_READ,
  GLOBAL_CONFIGURATION_WRITE,
} from "context/auth";

export const NavigationList = withRouter(
  ({
     notificationListOpen, onListItemClick = () => {
    }, location
   }) => {
    const [selectedMenuPath, setSelectedMenuPath] = useState();

    useEffect(
      () => setSelectedMenuPath("/" + location.pathname.split("/")[1]),
      [location]
    );

    return (
      <div className="d-flex">
        <Slide
          direction="right"
          in={!notificationListOpen}
          mountOnEnter
          unmountOnExit
        >
          <List>
            <NavigationListItem
              allowedPrivileges={[ORDER_READ]}
              itemKey={"orders"}
              linkPath={"/orders"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.orders"}
            >
              <OrdersListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[CAR_READ]}
              itemKey={"cars"}
              linkPath={"/cars"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.cars"}
            >
              <CarsListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[DRIVER_READ]}
              itemKey={"drivers"}
              linkPath={"/drivers"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.drivers"}
            >
              <DriversListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[CONTRACTOR_READ]}
              itemKey={"contractors"}
              linkPath={"/contractors"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.contractors"}
            >
              <ContractorsListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[FERRY_SERVICE_READ]}
              itemKey={"ferryServices"}
              linkPath={"/ferry-services"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.ferryServices"}
            >
              <FerryServicesListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[USER_READ]}
              itemKey={"users"}
              linkPath={"/users"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.users"}
            >
              <UsersListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[GROUP_READ]}
              itemKey={"groups"}
              linkPath={"/groups"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.groups"}
            >
              <GroupsListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[USER_GROUP_READ]}
              itemKey={"users-groups"}
              linkPath={"/user-groups"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.userGroups"}
            >
              <UserGroupsListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[GLOBAL_CONFIGURATION_WRITE]}
              itemKey={"admin-panel"}
              linkPath={"/admin-panel"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.adminPanel"}
            >
              <AdminPanelIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[CUSTOM_FIELDS_READ]}
              itemKey={"customFields"}
              linkPath={"/custom-fields"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.customFields"}
            >
              <CustomFieldsListIcon className={styles.icon}/>
            </NavigationListItem>
            <NavigationListItem
              allowedPrivileges={[MY_PROFILE_READ]}
              itemKey={"loggedUser"}
              linkPath={"/my-profile"}
              currentlySelectedPath={selectedMenuPath}
              onClick={onListItemClick}
              label={"menu.profile"}
            >
              <ProfileIcon className={styles.icon}/>
            </NavigationListItem>
          </List>
        </Slide>
        <div className="position-absolute overflow-hidden">
          <Slide
            direction="left"
            in={notificationListOpen}
            mountOnEnter
            unmountOnExit
          >
            <List>
              <NotificationsList/>
            </List>
          </Slide>
        </div>
      </div>
    );
  }
);

function NavigationListItem({
                              allowedPrivileges,
                              itemKey,
                              linkPath,
                              label,
                              currentlySelectedPath,
                              onClick,
                              children: icon,
                            }) {
  const {t} = useTranslation();

  const currentPathHighlight = useCallback(() => {
    return [
      styles.iconBackground,
      linkPath === currentlySelectedPath && styles.currentPageIconBackground,
    ];
  }, [linkPath, currentlySelectedPath]);

  return (
    <AccessControl allowedPrivileges={allowedPrivileges}>
      <ListItem
        className={styles.listItem}
        button
        key={itemKey}
        component={Link}
        to={linkPath}
        onClick={onClick}
      >
        <ListItemIcon>
          <div className={classNames(currentPathHighlight())}>{icon}</div>
        </ListItemIcon>
        <ListItemText primary={t(label)}/>
      </ListItem>
    </AccessControl>
  );
}
